let showFunc = () => { console.warn("Loader is not yet mounted to the DOM."); };
let hideFunc = () => {};
let isOpenFunc = () => false;

const loaderService = {
	setMethods(show, hide, isOpen) {
		showFunc = show;
		hideFunc = hide;
		isOpenFunc = isOpen;
	},
	show(options) {
		showFunc(options);
	},
	hide() {
		hideFunc();
	},
	isOpen() {
		return isOpenFunc();
	}
};

export default loaderService;
